import classnames from 'classnames';
import React from 'react';
import { FormLabel, Typography } from '@material-ui/core';

export type FormFieldProps = {
  value?: string | number | null;
  label: string;
  className?: string;
  showNull?: boolean;
};

export const ReadOnlyField = ({
  value,
  label,
  className,
  showNull,
}: FormFieldProps) => {
  const classes = classnames('form-read-only', className);

  if (!value && !showNull) {
    return null;
  }
  return (
    <div className={classes}>
      <FormLabel>
        {label}
      </FormLabel>
      <Typography className="form-value">{value}</Typography>
    </div>
  );
};
